import { useEffect, type Dispatch, type SetStateAction } from 'react';
import type { DailyQuestAssignAndGetResponse, DailyQuestWithProgress } from '../../../models/apiTypes';
import { getAllQuests } from '../../../utils/quest/questHelpers';
import { globalClaimedQuestTimestamps } from '../constants';

export interface UseClaimedRewardSyncParams {
  hourlyQuestsData: DailyQuestAssignAndGetResponse | undefined;
  marketingQuestsData: DailyQuestAssignAndGetResponse | undefined;
  dailyQuestsData: DailyQuestAssignAndGetResponse | undefined;
  isOpen: boolean;
  asScreen: boolean | undefined;
  setClaimedQuestIds: Dispatch<SetStateAction<Set<number>>>;
}

export function useClaimedRewardSync({
  hourlyQuestsData,
  marketingQuestsData,
  dailyQuestsData,
  isOpen,
  asScreen,
  setClaimedQuestIds,
}: UseClaimedRewardSyncParams): void {
  // Синхронізуємо стан забраних нагород з бекенду тільки коли модалка відкрита
  useEffect(() => {
    if (!isOpen && !asScreen) return;

    const allQuests = getAllQuests(
      hourlyQuestsData?.quests,
      dailyQuestsData?.quests,
      marketingQuestsData?.quests
    );

    if (allQuests.length > 0) {
      setClaimedQuestIds(prev => {
        const merged = new Set(prev);
        allQuests.forEach((quest: DailyQuestWithProgress) => {
          if (quest.reward_claimed && quest.user_quest_id) {
            merged.add(quest.user_quest_id);
            globalClaimedQuestTimestamps.delete(quest.user_quest_id);
          }
        });
        return merged;
      });
    }
  }, [hourlyQuestsData, marketingQuestsData, dailyQuestsData, isOpen, asScreen, setClaimedQuestIds]);
}
